import {
  Button,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Paper,
} from "@mui/material";
import { mapValues } from "lodash";
import { ReactNode } from "react";

type Option = {
  label: string,
  selected: boolean,
};

export type TransferListProps = {
  unselectedLabel: ReactNode,
  selectedLabel: ReactNode,
  selected: Record<string, Option>
  setSelected: (newOptions: Record<string, Option>) => void,
}

// Loosely based on https://mui.com/material-ui/react-transfer-list/
export default function TransferList({ selectedLabel, unselectedLabel, selected, setSelected } : TransferListProps) {
  const left = Object.keys(selected).filter(key => !selected[key].selected);
  const right = Object.keys(selected).filter(key => selected[key].selected);

  const customList = (keys: string[]) => (
    <Paper sx={{ width: 200, height: 230, overflow: 'auto', mt: 1 }}>
      <List dense component="div" role="list">
        {keys.map(key => {
          return (
            <ListItemButton
              key={key}
              role="listitem"
              onClick={() => setSelected({
                ...selected,
                [key]: {
                  ...selected[key],
                  selected: !selected[key].selected,
                },
              })}
            >
              <ListItemText primary={selected[key].label} />
            </ListItemButton>
          );
        })}
      </List>
    </Paper>
  );

  return (<Grid
    container
    spacing={2}
    sx={{ alignItems: 'center' }}
  >
    <Grid item>
      {unselectedLabel}
      {customList(left)}
    </Grid>
    <Grid item>
      <Grid container direction="column" sx={{ alignItems: 'center' }}>
        <Button
          sx={{ my: 0.5 }}
          variant="outlined"
          size="small"
          onClick={() => setSelected(mapValues(selected, option => ({...option, selected: true })))}
          disabled={left.length === 0}
          aria-label="move all right"
        >
          ≫
        </Button>
        <Button
          sx={{ my: 0.5 }}
          variant="outlined"
          size="small"
          onClick={() => setSelected(mapValues(selected, option => ({...option, selected: false })))}
          disabled={right.length === 0}
          aria-label="move all left"
        >
          ≪
        </Button>
      </Grid>
    </Grid>
    <Grid item>
      {selectedLabel}
      {customList(right)}
    </Grid>
  </Grid>);
}
